import { seriesEntries } from '@/mocks/series';
import SectionHeading from './SectionHeading';

export default function SeriesSection() {
  return (
    <section id="series" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          eyebrow="04 / 系列与续集"
          title="从 1993 到 2011：系列作品的时间线"
          desc="「蜜桃成熟时」在多年间延伸出多部后续作品。它们大多是在题材与命名上的延续，故事之间并不完全连贯，可按年份依次了解其演变。"
        />

        <div className="relative mt-10">
          <div className="absolute left-[19px] top-2 hidden h-[calc(100%-16px)] w-px bg-background-300 md:left-0 md:top-[19px] md:h-px md:w-full lg:block" />
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
            {seriesEntries.map((entry) => (
              <div key={entry.year} className="relative flex gap-4 lg:flex-col lg:gap-5">
                <div className="flex flex-col items-center lg:flex-row">
                  <span className="z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50">
                    <span className="h-3.5 w-3.5 rounded-full bg-accent-500" />
                  </span>
                </div>
                <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{entry.year}</span>
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-xs text-accent-900">
                      {entry.badge}
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">{entry.title}</h3>
                  <p className="mt-1 font-label text-xs text-foreground-500">
                    导演 {entry.director} · {entry.crew}
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{entry.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}